const stats = [
  { num: "2,800+", label: "累计围观现场", icon: "ri-live-line" },
  { num: "1200万", label: "全网累计阅读", icon: "ri-eye-line" },
  { num: "98%", label: "速报及时率", icon: "ri-timer-flash-line" },
  { num: "24h", label: "全天候持续更新", icon: "ri-time-line" },
];

const reviews = [
  {
    name: "追剧小八",
    role: "追热点重度用户",
    text: "决赛夜那天就是靠 17吃瓜 蹲完整场名场面，文字+图片直播比刷论坛轻松太多了，节奏拿捏得刚刚好。",
    tag: "围观体验",
  },
  {
    name: "路过的吃瓜群众",
    role: "通勤党",
    text: "每天通勤路上必刷「热点速报」，几分钟就能把今天值得看的事都理清楚，帮我省了不少瞎刷的时间。",
    tag: "速报效率",
  },
  {
    name: "小雨爱吃瓜",
    role: "休闲爱好者",
    text: "内容三观挺正的，该理性吃瓜的地方讲得很清楚，没有那种为了流量乱带的节奏，看着放心。",
    tag: "内容态度",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-32 mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
        {/* about text */}
        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-2 text-xs font-medium text-secondary-700">
            <i className="ri-heart-3-line text-base" aria-hidden="true"></i>
            ABOUT US
          </span>
          <h2 className="font-heading mt-2 text-2xl md:text-3xl font-bold text-foreground-950">
            关于 17吃瓜
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            17吃瓜 是一个面向全网用户的<strong className="font-semibold text-foreground-950">热点资讯与现场直击平台</strong>。我们相信，好的资讯不该让人疲于奔命地在各平台之间来回切换——于是我们把全网正在发生、值得围观的事件，以清晰、及时、有观点的方式聚合在一起。
          </p>
          <p className="mt-3 text-base leading-relaxed text-foreground-700">
            我们坚持<strong className="font-semibold text-foreground-950">「先核实、后发布」</strong>的内容原则，将「现场直击」的客观事实与「观点解读」清晰区分，对存疑信息明确标注，倡导理性吃瓜、理性围观。在碎片时间里，带你高效掌握最新动态，让每一次围观都有价值、不迷路。
          </p>

          <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-3">
            {stats.map((s) => (
              <div key={s.label} className="rounded-xl border border-background-200 bg-background-50 p-4 text-center">
                <span className="mx-auto flex h-9 w-9 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                  <i className={`${s.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <p className="font-label mt-3 text-xl text-foreground-950">{s.num}</p>
                <p className="mt-1 text-[11px] text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* reviews */}
        <div className="lg:col-span-5">
          <h3 className="font-heading mb-4 text-xl font-bold text-foreground-950">围观群众怎么说</h3>
          <div className="space-y-3">
            {reviews.map((r) => (
              <figure key={r.name} className="rounded-xl border border-background-200 bg-background-50 p-5">
                <div className="flex items-center justify-between">
                  <span className="whitespace-nowrap rounded-md bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800">
                    {r.tag}
                  </span>
                  <span className="flex gap-0.5 text-accent-500" aria-label="5 星评价">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-xs" aria-hidden="true"></i>
                    ))}
                  </span>
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                  「{r.text}」
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-foreground-900 text-xs font-medium text-background-50">
                    {r.name.charAt(0)}
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{r.name}</p>
                    <p className="text-[11px] text-foreground-400">{r.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}